// format.js includes utility functions for formatting JSX

import React from "react";
import { css } from "@emotion/react";

import {
  accentColor1,
  accentColor2,
  accentColor3,
  accentColor4,
  logoColor1,
  logoColor2,
  logoColor3,
  logoColor4,
} from "../styles/color";

///
/// This function will take in a timestamp in firestore format, and output
/// it to how we want it displayed.
///
export const formatTimestamp = (timestamp) => {
  const currentTime = new Date();
  const timeDifference = currentTime - timestamp.toDate();

  const diffSeconds = Math.ceil(timeDifference / 1000);
  const diffMinutes = Math.ceil(timeDifference / (1000 * 60));
  const diffHours = Math.ceil(timeDifference / (1000 * 60 * 60));
  const diffDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

  // Converts from milliseconds to the appropriate time stamp
  if (diffSeconds < 60) {
    return diffSeconds + "s";
  } else if (diffMinutes < 60) {
    return diffMinutes + "min";
  } else if (diffHours < 24) {
    return diffHours + "h";
  } else if (diffDays < 7) {
    return diffDays + "d";
  } else if (diffDays < 30) {
    return Math.floor(diffDays / 7) + "w";
  } else if (diffDays < 365) {
    return Math.floor(diffDays / 30) + "m";
  } else {
    return Math.floor(diffDays / 365) + "y";
  }
};

export const colorizeString = (str) => {
  let colorizedString = [];
  let colors = [accentColor1, accentColor2, accentColor3, accentColor4];
  let colorIndex, color;
  let priorColor1 = 0;
  let priorColor2 = 0;
  let selectingColor = true;

  for (let i = 0; i < str.length; i++) {
    if (str[i] === ` `) {
      colorizedString.push(<span key={i}> </span>);
    } else {
      // Select a random color
      while (selectingColor) {
        colorIndex = Math.floor(Math.random() * colors.length);
        color = colors[colorIndex];

        // Make sure the selected color isn't too close to itself
        if (color !== priorColor1 && color !== priorColor2) {
          priorColor2 = priorColor1;
          priorColor1 = color;
          selectingColor = false;
        }
      }

      // Set remaining available colors
      colors.splice(colorIndex, 1);
      if (colors.length === 0) {
        colors = [accentColor1, accentColor2, accentColor3, accentColor4];
      }

      // Append a colorized letter to the JSX array
      colorizedString.push(
        <span
          key={i}
          css={css`
            color: ${color};
          `}
        >
          {str[i]}
        </span>
      );

      selectingColor = true;
    }
  }

  return <span>{colorizedString}</span>;
};

export const getColorArray = (len) => {
  // This function returns an array of randomized color values
  let baselineColors = [logoColor1, logoColor2, logoColor3, logoColor4];

  let colorArray = [];
  let colors = baselineColors.slice();
  let colorIndex, color;
  let priorColor1 = 0;
  let priorColor2 = 0;
  let selectingColor = true;

  for (let i = 0; i < len; i++) {
    // Select a random color
    while (selectingColor) {
      colorIndex = Math.floor(Math.random() * colors.length);
      color = colors[colorIndex];

      // Make sure the selected color isn't too close to itself
      if (color !== priorColor1 && color !== priorColor2) {
        priorColor2 = priorColor1;
        priorColor1 = color;
        selectingColor = false;
      }
    }

    // Set remaining available colors
    colors.splice(colorIndex, 1);
    if (colors.length === 0) {
      colors = baselineColors.slice();
    }

    // Append a color to the array
    colorArray.push(color);

    selectingColor = true;
  }

  return colorArray;
};
